import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';

import { Grid, Typography } from '@mui/material';
export default function Loaderwithtext({
    open,
    setOpen,
    text
}) {

  return (
    <>
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
            // onClick={setO}
            >
              <Grid sx={{width:{xs:"85%"}}} direction={"column"} display={'flex'} justifyContent={'center'} alignItems={'center'}>
              {text &&  <Typography>{text}</Typography>}
            <CircularProgress color="inherit" />
              </Grid>
        </Backdrop>
            </>
  );
}
